/// <amd-module name="Wit/SprintsHub/SprintsView/Components/Taskboard/Contracts/Contracts" />
export enum WorkItemArrayEvents {
    /** used when a work item was removed from array */
    RemoveWorkItem = "RemoveWorkItem"
}
